<template>
	<bsh-modal 
		titulo="Novo Cliente"
		tamanho="modal-lg"
		:name="name">
		<template v-slot:default>
	        <cliente-form
				:dados="dados" 
	        	:name="name" 
	        	:errors="errors">
	        </cliente-form>
	    </template>
	    <template v-slot:footer>
        	<button 
				ref="btnRequest"
        		type="button"
        		class="btn btn-primary" 
        		@click="create">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	import Cliente from "./../../models/Cliente.js";
	export default {
		data(){
			return {
				dados: new Cliente(),
				name: 'create_cliente',
				errors: []
			}
		}, 
		methods: {
			create(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
	            axios.post(this.$url+'/api/adm/clientes/store', (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.dados = new Cliente()
	              	this.$emit('reload')
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	}
		},
	}
</script>